import {Component, OnInit, Input, SimpleChanges} from '@angular/core';
import {DictItemService} from "../../../routes/jy-dict/dict-info/service/dict-item.service";
import {CacheService} from '@delon/cache';

@Component({
  selector: 'dict-span',
  template: `
    {{dictItemValue}}`
})
export class DictSpanComponent implements OnInit {
  @Input() dictCode;
  @Input() dictItemCode;
  @Input() allowEnglish:boolean;

  public dictItemValue = "";

  constructor(private dictItemService:DictItemService, private srv:CacheService) {
    this.allowEnglish = false;
  }

  ngOnInit() {
  }

  ngOnChanges(changes:SimpleChanges) {
    if (this.dictCode) {
      if (this.dictItemCode) {
        var value = this.srv.getNone(this.dictCode + "-" + this.dictItemCode);
        if (value) {
          this.dictItemValue = "" + value;
        } else {
          this.dictItemService.getByDictCodeAndItemCodes(this.dictCode, this.dictItemCode, this.allowEnglish).subscribe((data)=> {
            if (data['value']) {
              this.dictItemValue = data['value'];
            } else {
              this.dictItemValue = "";
            }
            this.srv.set(this.dictCode + "-" + this.dictItemCode, this.dictItemValue)
          });
        }
      }
    } else {
      this.dictItemValue = "";
    }
  }



}
